import * as React from 'react';
import classnames from 'classnames';

import { MissingDependencyException } from '@/exceptions';
import { iPlan } from '@/interfaces/plans';
import { HTML } from '@/components/content';
import SiteSettings from '@/services/siteSettings'

interface iProps {
    /**
     * Enables the "active" state
     */
    active?: boolean;
    /**
     * Optional child elements rendered underneath the description.
     */
    children?: React.ReactNode | React.ReactNode[];
    /**
     * Puts the component into a "disabled" state.
     */
    disabled?: boolean;
    /**
     * The plan data.
     */
    plan: iPlan;
}

export const PlanPreview: React.SFC<iProps> = (props: iProps) => {
    const { active, children, disabled, plan } = props;
    if (!plan) {
        throw new MissingDependencyException('plan', '<PlanPreview>');
    }

    const className = classnames('plan-preview', {
        'plan-preview--status-active': active,
        'plan-preview--status-disabled': disabled,
    })

    return (
        <article className={className}>
            {active ? (
                <aside className="plan-preview__active-banner">Your Current Plan</aside>
            ) : null}
            <article>
              <img src={plan.img}/>
              <h4 className="plan-preview__title">{plan.name}</h4>
                <p className="plan-preview__price">{SiteSettings.get('currency_symbol')}{`${(plan.price / 100).toFixed(2)}`}</p>
                <p className="plan-preview__sub">Per {plan.period}</p>
                <HTML className="plan-preview__content plan-preview__description" value={plan.description} />
                {children ? (
                    <div className="plan-preview__content">
                        {children}
                    </div>
                ) : null}
            </article>
        </article>
    )
}
